export const REPORT_ENDPOINT = '/admin/widget-performance';
export const ACCOUNTS_ENDPOINT = '/admin/widget-performance/accounts';
export const WIDGETS_ENDPOINT = '/admin/widget-performance/widgets';

export const URLS_PER_PAGE = 10;
